module.exports = __webpack_public_path__ + "static/media/wreath.3c025ea3.png";